import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=312a9a27&scoped=true"
import script from "./Impact.vue?vue&type=script&lang=js"
export * from "./Impact.vue?vue&type=script&lang=js"
import style0 from "./Impact.vue?vue&type=style&index=0&id=312a9a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a9a27",
  null
  
)

export default component.exports